import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SessionService } from '@core';
import { BaseResult } from '@shared';

@Injectable({
    providedIn: 'root'
})
export class SolverService {
    private readonly httpClient = inject(HttpClient);
    private readonly sessionService = inject(SessionService);


    public stopSolvers(): Observable<BaseResult> {
        const url = `${this.sessionService.getApiUrl()}/stop_solvers/${this.sessionService.requestId}`;
        const body = {};
        return this.httpClient.put<BaseResult>(url, body);
    }
}
